import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';

const imageDimension = 'min(40vw, 60vh)';
const imageDimensionMobile = '70vw';

export const changeAnythingModalStyles = {
	modalWrapper: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',

		outline: 'none',
	},
	modalBody: {
		height: { xs: 'fit-content', [tabletBreakpoint]: '80vh' },
		maxHeight: { xs: '80vh', [tabletBreakpoint]: '80vh' },

		display: 'flex',
		alignItems: { xs: 'start', [tabletBreakpoint]: 'center' },
		gap: '16px',

		position: 'relative',
		overflow: 'auto',
	},
	crossButton: {
		position: 'absolute',
		top: 0,
		right: 0,

		minWidth: 'unset',
		padding: 0,

		transform: 'translate(100%, -100%)',
		zIndex: 1,

		'& svg': {
			stroke: colorPalette.light2,

			height: '32px',
			width: 'auto',
		},
		'&.Mui-disabled': {
			'& svg': {
				stroke: colorPalette.light5,
			},
		},
	},

	arrowButton: {
		cursor: 'pointer',

		'& svg': { height: { xs: '24px', [tabletBreakpoint]: '40px' }, width: 'auto' },
	},

	contentWrapper: {
		backgroundColor: 'colors.dark6',

		height: '100%',
		overflow: 'auto',
	},
	detailScreenContent: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'stretch',
	},

	detailScreenImgWrapper: {
		flexShrink: 0,
		width: { xs: imageDimensionMobile, [tabletBreakpoint]: imageDimension },
		height: { xs: imageDimensionMobile, [tabletBreakpoint]: imageDimension },
	},
	detailScreenImgCont: {
		width: '100%',
		paddingTop: '100%',

		position: 'relative',
	},
	image: {
		position: 'absolute',
		top: 0,
		right: 0,
		bottom: 0,
		left: 0,

		paddingBottom: { xs: '16px', [tabletBreakpoint]: 0 },

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',

		overflow: 'hidden',

		'& img': {
			height: '100%',
			width: '100%',
			objectFit: 'contain',
		},
	},

	promptDetailsCont: {
		width: '100%',

		display: 'flex',
		flexDirection: 'column',

		overflow: 'hidden',
	},
	promptDetailsScrollWrapper: {
		flexGrow: 1,
		overflow: { xs: 'auto', [tabletBreakpoint]: 'scroll' },
	},
	useImageButtonSection: {
		width: '100%',
		marginTop: '16px',
		display: 'grid',
		gridTemplateColumns: {
			xs: 'repeat(auto-fill, minmax(150px, 1fr))',
			[tabletBreakpoint]: 'repeat(auto-fill, minmax(150px, 1fr))',
		},
		gridTemplateRows: 'auto',
		gridGap: '8px',
	},
	controlnetFacelockSection: {
		card: {
			width: '100%',
			padding: '12px',
			borderRadius: '4px',

			display: 'flex',
			flexDirection: 'column',
			alignItems: 'start',
		},
		subCard: {
			padding: '12px',
			borderRadius: '4px',
			border: `1px solid ${colorPalette.dark1}`,

			backgroundColor: 'colors.dark2',

			display: 'flex',
			alignItems: 'center',
			gap: '12px',

			cursor: 'pointer',

			'& svg': { height: '24px', width: 'auto' },
		},
	},

	detailScreenButtonsCont: {
		padding: '24px 16px',
		borderTop: `1px solid ${colorPalette.dark4}`,

		backgroundColor: 'colors.dark5',

		display: 'flex',
		flexDirection: {
			xs: 'column',
			sm: 'row',
			md: 'column',
			xxl: 'row',
		},
		justifyContent: 'center',
		gap: '16px',
	},
	buttonStyles: {
		padding: '10px 10px',
		borderRadius: '4px',

		textTransform: 'none',

		display: 'flex',
		alignItems: 'center',
		gap: '4px',

		'& svg': { height: '24px', width: 'auto' },
	},
	downloadButton: {
		flex: 1,
		minWidth: 'unset',

		backgroundColor: 'colors.light1',
		'&:hover': { backgroundColor: 'colors.light1' },

		'&.Mui-disabled': {
			color: 'colors.light5',
			backgroundColor: 'colors.dark2',
		},
	},
	deleteButton: {
		minWidth: 'unset',
		backgroundColor: 'colors.dark3',

		'&:hover': { backgroundColor: 'colors.dark3' },
	},
};
